import React from 'react'
import BlogPage from './BlogPage'

const Blog = () => {
  return (
    <BlogPage/>
  )
}

export default Blog